export default {
  statuses: {
    pending: 'Pending',
    canceled: 'Canceled',
    in_progress: 'In progress',
    terminated: 'Completed',
  },
  fields: {
    hour: 'Hour',
    status: 'Status',
    start_address: 'Start address',
    end_address: 'End address',
    phone: 'Phone',
    name: 'Name',
    driver: 'Driver',
    driver_name: 'Driver name',
    lat: 'Latitude',
    lng: 'Longitude',
    WpMessages: 'Messages',
    WpActions: 'Actions',
    comment: 'Comment',
    time: 'Time',
    fee: 'Fee',
    deducted: 'Deducted',
    fee_multiplier: 'Fee Multiplier',
    distance: 'Distance',
    origin: 'Origin',
    arrived_at: 'Arrival',
    trip_started_at: 'Trip started',
    trip_ended_at: 'Trip ended',
    wait_for_arrival: 'Wait for arrival',
    wait_for_pickup: 'Wait at pickup',
    trip_duration: 'Trip duration',
  },
  origin: {
    admin: 'Admin panel',
    bot: 'WhatsApp Bot',
    test: 'Test',
    driver: 'Driver',
    unknown: 'Unidentified',
  },
  labels: {
    code: 'Code',
    phone: 'Phone',
    name: 'Name',
    start_address: 'Pickup address',
    end_address: 'Drop-off address',
    comment: 'Comment',
    count: 'Qty.',
    line: 'Line',
    test_toggle: 'Test service',
    target_driver: 'Target driver',
  },
  edit_start_address: 'Edit pickup address',
  current_start_address: 'Current pickup address',
  self_service_trip: 'Self-service trip',
  edit_comment: 'Edit comment',
  current_comment: 'Current comment',
  placeholders: {
    end_address_optional: 'Enter destination address (optional)',
    phone: '300 000 0000',
    name: 'Passenger name',
    start_address: 'Pickup point',
    end_address: 'Destination (optional)',
    comment: 'Additional note',
  },
  history: 'History',
  total: 'Total',
  pending_title: 'Pending services',
  in_progress_title: 'Services in progress',
  title: 'Service | Services',
  route_integrity: {
    tab: 'Route integrity',
    title: 'Route integrity report',
    helper_text: 'Flagged trips are evidence for review, not proof of manipulation. Weigh the ratio against the total trips before drawing conclusions.',
    fields: {
      driver: 'Driver',
      total_trips: 'Total trips',
      flagged_trips: 'Flagged trips',
      flagged_trips_tooltip: 'A flagged trip is a terminated trip that was started through the trip flow but ended with no usable route (empty or missing route) or with a recorded distance of zero — a pattern consistent with GPS suppression. It is evidence for review, not proof.',
      flagged_ratio: 'Flagged ratio',
      flagged_ratio_tooltip: "It is the number of flagged trips divided by the driver's total counted trips in the range, shown as a percentage. Weigh it together with the total number of trips: 1/1 (100%) is not the same as 7/10.",
    },
    empty_state: 'No counted trips in the selected date range.',
    drilldown_title: 'Flagged services — {driver}',
  },
  messages: {
    new_client: 'Client does nor exists, therefor has been created a new one',
    no_start_loc: 'No place selected!',
    driver_assigned: 'Service has a driver assigned',
    has_applicants: 'Cannot restart the service because drivers are currently applied',
    start_address_updated: 'Pickup address updated',
    branch_required: 'Select a branch to update the pickup address',
    comment_updated: 'Comment updated',
    test_driver_required: 'You must select a driver for the test service',
    test_notice: 'This is a test service: it will only be visible to the selected driver and will not generate charges to the driver.',
  }
}
